<!-- MFITTで発車時刻を過ぎて購入操作をした場合 -->
<template>
  <ItemDialog ref="canNotPurchaseAfterDeparture" image-type="alert">
    <template #content-area>
      <p class="text-center">
        期限を過ぎたため購入はできません。<br />
        購入できるのは発車前までです。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotPurchaseAfterDeparture",
  setup() {
    const canNotPurchaseAfterDeparture = ref(null);

    const openDialog = () => {
      canNotPurchaseAfterDeparture.value.open();
    };

    const closeDialog = () => {
      canNotPurchaseAfterDeparture.value.close();
    };

    return {
      canNotPurchaseAfterDeparture,
      openDialog,
      closeDialog,
    };
  },
};
</script>
